import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import { FaLightbulb } from "react-icons/fa";

const LightingElectricalTipsPage = () => {
  return (
    <Box minH="100vh" bg="white">
      {/* Hero Section */}
      <Box
        bg="white"
        py={{ base: 16, md: 24 }}
        px={{ base: 6, md: 12 }}
        textAlign="center"
      >
        <Heading
          as="h1"
          fontSize={{ base: "4xl", md: "6xl" }}
          fontWeight="800"
          color="gray.900"
          mb={6}
          fontFamily="'Work Sans', sans-serif"
        >
          Lighting and Electrical Tips
        </Heading>
        <Text
          fontSize={{ base: "lg", md: "xl" }}
          color="gray.600"
          maxW="2xl"
          mx="auto"
        >
          Want to enhance your home lighting and electrical setup? Check out
          these valuable tips for safer installations and improved lighting
          efficiency!
        </Text>
      </Box>

      {/* Content Section */}
      <Box bg="gray.50" py={{ base: 12, md: 20 }} px={{ base: 6, md: 12 }}>
        <Box maxW="1200px" mx="auto">
          {/* Tools & Materials Section */}
          <Box
            mb={12}
            bg="white"
            border="1px solid"
            borderColor="gray.200"
            borderRadius="xl"
            p={8}
            boxShadow="sm"
          >
            <Heading
              as="h2"
              fontSize="2xl"
              fontWeight="700"
              color="gray.900"
              mb={4}
            >
              Tools & Materials You'll Need
            </Heading>
            <List spacing={3}>
              <ListItem>
                <ListIcon as={FaLightbulb} color="orange.500" />
                Screwdrivers (Flat and Phillips)
              </ListItem>
              <ListItem>
                <ListIcon as={FaLightbulb} color="orange.500" />
                Voltage Tester
              </ListItem>
              <ListItem>
                <ListIcon as={FaLightbulb} color="orange.500" />
                Wire Strippers
              </ListItem>
              <ListItem>
                <ListIcon as={FaLightbulb} color="orange.500" />
                Electrical Tape
              </ListItem>
            </List>
          </Box>

          {/* Electrical Tips */}
          <VStack align="start" spacing={8}>
            {/* Tip 1 */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Heading
                as="h2"
                fontSize="2xl"
                fontWeight="700"
                color="gray.900"
                mb={2}
              >
                Tip 1: Use Energy-Efficient LED Bulbs
              </Heading>
              <Text fontSize="md" color="gray.600" mb={4}>
                Switching to LED bulbs can significantly reduce your energy
                consumption while providing bright, long-lasting illumination.
              </Text>
            </Box>

            {/* Tip 2 */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Heading
                as="h2"
                fontSize="2xl"
                fontWeight="700"
                color="gray.900"
                mb={2}
              >
                Tip 2: Install Dimmer Switches
              </Heading>
              <Text fontSize="md" color="gray.600" mb={4}>
                Dimmers allow you to control the brightness of your lights,
                creating the perfect ambiance for any occasion while saving
                energy.
              </Text>
            </Box>

            {/* Tip 3 */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Heading
                as="h2"
                fontSize="2xl"
                fontWeight="700"
                color="gray.900"
                mb={2}
              >
                Tip 3: Label Your Circuit Breaker Panel
              </Heading>
              <Text fontSize="md" color="gray.600" mb={4}>
                Clearly labeling your circuit breakers can save time during
                repairs or power outages, helping you quickly identify which
                breaker controls which area of your home.
              </Text>
            </Box>

            {/* Tip 4 */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Heading
                as="h2"
                fontSize="2xl"
                fontWeight="700"
                color="gray.900"
                mb={2}
              >
                Tip 4: Use GFCI Outlets in Wet Areas
              </Heading>
              <Text fontSize="md" color="gray.600" mb={4}>
                Install Ground Fault Circuit Interrupter (GFCI) outlets in areas
                prone to moisture, such as bathrooms and kitchens, to prevent
                electrical shocks.
              </Text>
            </Box>

            {/* Final Tip */}
            <Box
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              p={8}
              boxShadow="sm"
              w="100%"
            >
              <Text
                fontSize={{ base: "lg", md: "xl" }}
                fontWeight="700"
                color="gray.900"
              >
                Remember to always prioritize safety when working with
                electrical systems. If you're ever in doubt, consult a
                professional electrician.
              </Text>
            </Box>
          </VStack>
        </Box>
      </Box>
    </Box>
  );
};

export default LightingElectricalTipsPage;
